// VideoGrid.jsx
import { Track } from 'livekit-client';
import TrackTile from './TrackTile';

export default function VideoGrid({ participantsWithTracks, onTileClick, networkQuality, activeSpeakerSid, screenSharingSids }) {
  return (
    <div className="video-grid">
      {(participantsWithTracks || []).map(({ participant, cameraTrack }) => {
        const micPub = participant?.getTrack?.(Track.Source.Microphone);
        const camPub = participant?.getTrack?.(Track.Source.Camera);
        const hasCameraPub = Boolean(camPub);
        const videoMuted = hasCameraPub
          ? (camPub.isMuted ?? !camPub.track)
          : true;
        return (
          <TrackTile
            key={participant.sid}
            participant={participant}
            track={cameraTrack || null}
            isActive={participant.sid === activeSpeakerSid}
            networkLevel={networkQuality?.[participant.sid] ?? 0}
            isAudioMuted={micPub ? micPub.isMuted : true}
            isVideoMuted={videoMuted}
            isScreenSharing={screenSharingSids?.has?.(participant.sid)}
            onClick={() => onTileClick(participant.sid)}
          />
        );
      })}
    </div>
  );
}
